import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

const markdownRemarkPlugins = [remarkGfm];
const markdownRehypePlugins = [rehypeRaw];

type EligibilityRequirementsListProps = {
  requirements: string[];
};

export const EligibilityRequirementsList = ({ requirements }: EligibilityRequirementsListProps) => {
  if (requirements.length === 0) return null;

  return (
    <div className="w-full max-w-[340px] text-left">
      <p className="text-xs font-semibold text-cede-text-secondary uppercase tracking-wide mb-2">
        Eligibility requirements
      </p>
      <ul className="space-y-2.5">
        {requirements.map((req, i) => (
          <li key={i} className="flex items-start gap-2 text-sm leading-5 text-cede-text-primary">
            <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-cede-primary shrink-0" />
            <ReactMarkdown
              className="text-sm leading-5 text-cede-text-primary [&>p]:inline"
              remarkPlugins={markdownRemarkPlugins}
              rehypePlugins={markdownRehypePlugins}
              components={{
                p: ({ children }) => <span>{children}</span>,
                a: ({ children, ...props }) => (
                  <a
                    {...props}
                    className="text-cede-primary underline decoration-transparent transition hover:decoration-inherit break-all"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {children}
                  </a>
                ),
                strong: ({ children }) => <strong className="font-semibold text-cede-primary">{children}</strong>,
              }}
            >
              {req}
            </ReactMarkdown>
          </li>
        ))}
      </ul>
    </div>
  );
};
